module.exports = __webpack_public_path__ + "img/logo-icon.eac2a201.png";